import Alpine from "alpinejs";
import siteConfig from "../../modules/siteConfig";
Alpine.magic("siteConfig", () => {
    return siteConfig;
});